import { FETCH_QUESTION_AND_ANSWERS_REQUEST,FETCH_QUESTION_AND_ANSWERS_SUCCESS,FETCH_QUESTION_AND_ANSWERS_FAILURE } from "./actionTypes";

const initialState = {
  questions: [],
  loading: false,
  error: null,
};

const questionsAndAnswersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_QUESTION_AND_ANSWERS_REQUEST:
      return { ...state, loading: true };
    case FETCH_QUESTION_AND_ANSWERS_SUCCESS:
      return { ...state, loading: false, questions: action.payload };
    case FETCH_QUESTION_AND_ANSWERS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default questionsAndAnswersReducer;